/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { SEND_SINGLE_PURCHASE_REFERALS } from "../graphql/sendPurchaseReferals.mutation";
import { VApplication } from "../../../application";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface SendSinglePurchaseInviteUserProps {
  presentation: any;
  section?: any;
  type?: any;
  userEmail?: any;
  partition?: any;
  sectionOptType?: any;
}
export interface ISendSinglePurchaseInviteMethods extends IPluginMethodMap {
  sendSinglePurchaseInviteUser(args: SendSinglePurchaseInviteUserProps): Promise<any>;
}

export class SendSinglePurchaseInviteUserService implements IAgentPlugin {
  readonly methods: ISendSinglePurchaseInviteMethods;

  constructor() {
    this.methods = {
      sendSinglePurchaseInviteUser: this.sendSinglePurchaseInviteUser.bind(this),
    };
  }

  async sendSinglePurchaseInviteUser(args: SendSinglePurchaseInviteUserProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const { presentation, type, section, userEmail, partition, sectionOptType } = args;
    try {
      if (client) {
        const res = await client.mutate({
          mutation: SEND_SINGLE_PURCHASE_REFERALS,
          variables: {
            data: {
              email: userEmail,
              inviteType: "Discount",
              partition: partition,
              presentation: presentation,
              sectionOptType: sectionOptType,
              sections: type === "" ? null : section,
            },
            addIfNotExists: true,
            invite: false
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.sendPurchaseReferals,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  
}